import genderEnglish2Persian from "./genderEnglish2Persian";
import breadcrumbDictionary from "./breadcrumbDictionary";
import roleDictionary from "./roleDictionary";
import roleToUrl from "./roleToUrl";

const dictionary = {
  genderEnglish2Persian,
  breadcrumbDictionary,
  roleDictionary,
  roleToUrl,
};

export default dictionary;
